import { AuthGuard } from "@redotech/redo-customer-portal-app/contexts/auth";
import { ReturnConfirmation } from "@redotech/redo-customer-portal-app/portal-four/returns/confirmation";
import { Page } from "@redotech/redo-customer-portal-app/portal-four/shared-components/page";
import { t } from "@redotech/redo-i18n";
import { RouteObject } from "react-router-dom";
export const returnRoutes: RouteObject[] = [
  {
    path: ":returnId/exchange-conversion",
    lazy: async () => {
      const { ExchangeConversionScreen } =
        await import("@redotech/redo-customer-portal-app/portal-four/returns/exchange-conversion/exchange-conversion");
      return {
        element: (
          <Page>
            <ExchangeConversionScreen />
          </Page>
        ),
      };
    },
  },
  {
    path: ":returnId/claim-documents",
    lazy: async () => {
      const { AdditionalClaimDocumentsScreen } =
        // redont-allow-dynamic-import: route-level code splitting
        await import("@redotech/redo-customer-portal-app/portal-four/returns/additional-claim-documents/additional-claim-documents");
      return {
        element: (
          <Page>
            <AdditionalClaimDocumentsScreen />
          </Page>
        ),
      };
    },
  },
  {
    path: ":returnId/completeExchange",
    lazy: async () => {
      const { CompleteExchange } = await import("./complete-exchange");
      return { Component: CompleteExchange };
    },
  },
  {
    path: ":returnId",
    lazy: async () => {
      return {
        element: (
          <AuthGuard
            unauthorizedMessage={t(
              "You need to login again to see this return confirmation.",
            )}
          >
            <Page>
              <ReturnConfirmation />
            </Page>
          </AuthGuard>
        ),
      };
    },
  },
];
